import styled from 'styled-components';

export const Card = styled.div`
  padding: 32px;
  background-color: ${(props) => props.theme.colors['neutral-10']};
  border-radius: 16px;
  border: 1px solid;
  border-color: ${(props) => props.theme.colors['neutral-30']};
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.07);
  margin-bottom: 38px;
`;
